<template>
  <core-view>
    <div>
      <!-- Espaço para futuros filtros globais, se necessário -->
    </div>

    <component :is="componenteAtivo" :filters="filters" :cliente="cliente" :origem="rotaDeOrigem" @limpar-origem="limparOrigem" />

  </core-view>
</template>

<script>
import CoreView from '@/components/core/view/Index.vue';
import moment from 'moment';
import ResumoVendasCidade from '@/components/app/card/diversos/resumocidade/Index.vue';
import ResumoVendasGrupo from '@/components/app/card/diversos/resumogrupo/Index.vue';
import ResumoVendasCliente from '@/components/app/card/diversos/resumocliente/Index.vue';
import TabelaPedidos from '@/components/app/card/tabelas/tabelaPedidos/Index.vue';
import TabelaOrcamento from '@/components/app/card/tabelas/tabelaOrcamento/Index.vue';
import TabelaClientes from '@/components/app/card/tabelas/tabelaClientes/Index.vue';


export default {
  name: 'ViewDiversosResumo',

  components: {
    CoreView,
    ResumoVendasCidade,
    ResumoVendasGrupo,
    ResumoVendasCliente,
    TabelaPedidos,
    TabelaOrcamento,
    TabelaClientes,
  },

  data() {
    return {
      cliente: { nome: '', codigo: '' },
      filters: {},
      rotaDeOrigem: null,
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.rotaDeOrigem = to.query.origem || null; 
    });
  },

  beforeRouteLeave(to, from, next) {
    this.rotaDeOrigem = null;
    next();
  },

  created() {
    this.cliente = {
      nome: this.$route.query.clienteNome,
      codigo: this.$route.query.clienteCodigo,
    };
    if (this.idVendedorLogado) {
    this.$_recarregarDashboard();
  }
  },

  computed: {
    componenteAtivo() {
      return this.$route.query.relatorio || null;
    },
  },
  methods: {
    FormataDataGeral(date) {
      return moment.utc(date).format('DD/MM/YYYY');
    },
    limparOrigem() {
      this.rotaDeOrigem = null;
    }
  },
};
</script>
<style scoped>
.linha_botoes {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.btn {
  width: auto;
  min-width: 0px !important;
  padding: 0 1.5vw 0 1.5vw  !important;
}

@media screen and (max-width: 375px) {
  .btn {
    margin: 3px !important;
    margin-bottom: 8px !important;
  }
}

.center-text {
  display: flex;
  justify-content: center;
}

.ultimo {
  justify-self: right;
}

</style>
